import React from 'react';
import { X } from 'lucide-react';
export function Problem() {
  const problems = ['Videos de YouTube sin orden ni progresión', 'Tutoriales que asumen que ya sabés algo', 'Acordes sueltos que no podés encadenar en una canción', 'Te duelen los dedos, no sabés si es normal, y abandonás', 'Nunca llegás a tocar una canción completa', 'Empezás, lo dejás, volvés a empezar'];
  return <section className="w-full bg-fondo-crema text-fondo-principal py-section px-4" data-id="element-156">
      <h2 className="text-2xl font-bold text-center mb-4 leading-tight" data-id="element-157">
        ¿Cuántas veces más vas a dejar la guitarra guardada?
      </h2>
      <p className="text-center text-lg font-medium mb-8" data-id="element-158">
        Sin un sistema claro, siempre terminás igual.
      </p>

      <ul className="flex flex-col gap-4 mb-8" data-id="element-159">
        {problems.map((prob, idx) => <li key={idx} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border border-orange-100" data-id="element-160">
            <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-161" />
            <span className="font-medium text-gray-800" data-id="element-162">{prob}</span>
          </li>)}
      </ul>

      <div className="bg-botones-acentos text-white p-6 rounded-2xl text-center font-bold text-lg shadow-lg" data-id="element-163">
        No es falta de oído. Es falta de un sistema. Con Guitarra Fácil PRO, tu
        próximo intento puede ser el que sí funciona. 🎸
      </div>
    </section>;
}